(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/prolong-storage/assets/javascripts/prolong-storage.js') >= 0) return;  svs.modules.push('/components/tur/prolong-storage/assets/javascripts/prolong-storage.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const TWENTY_SECONDS_IN_MS = 20000;
const SEVEN_DAYS_IN_SECONDS = 7 * 24 * 60 * 60;
const SEVEN_DAYS_IN_MS = SEVEN_DAYS_IN_SECONDS * 1000;
const isServer = svs.isServer;
let logger;
let productMapping;
let drawgamesApiCaller;
if (isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  drawgamesApiCaller = trinidadCore.components.require('tur', 'api-caller').drawgamesApiCaller;
  logger = trinidadCore.logger('tur:prolong-storage');
  productMapping = trinidadCore.components.require('numbergames', 'product-mapping').productMapping;
} else {
  drawgamesApiCaller = svs.tur.apiCaller.drawgames;
  logger = new svs.core.log.Logger('tur:prolong-storage');
  productMapping = svs.numbergames.productMapping;
}
const keyMap = {
  eurojackpot: 'eurojackpotProlong',
  lotto: 'lottoProlong',
  keno: 'kenoProlong',
  vikinglotto: 'vikinglottoProlong',
  lyckoplatsen: 'lyckoplatsenProlong'
};
const cachedProlongData = {};
const inFlightProlongData = {};
const inFlightSetOperations = {};
const restartCachedDataTimeout = key => {
  var _cachedProlongData$ke;
  if ((_cachedProlongData$ke = cachedProlongData[key]) !== null && _cachedProlongData$ke !== void 0 && _cachedProlongData$ke.timeoutId) {
    clearTimeout(cachedProlongData[key].timeoutId);
  }
  if (!cachedProlongData[key]) {
    cachedProlongData[key] = {};
  }
  cachedProlongData[key].timeoutId = setTimeout(() => {
    delete cachedProlongData[key];
  }, TWENTY_SECONDS_IN_MS);
};
const setCachedData = (key, data) => {
  cachedProlongData[key] = {
    data
  };
  restartCachedDataTimeout(key);
};
const getObjectStoreData = async _ref => {
  let key = _ref.key,
    req = _ref.req;
  try {
    return await drawgamesApiCaller.getPlayerObjectstore({
      keys: key,
      req
    });
  } catch (error) {
    logger.error('Error getting from object store', error);
    return null;
  }
};
const postToObjectStore = async _ref2 => {
  let key = _ref2.key,
    value = _ref2.value,
    expires = _ref2.expires,
    req = _ref2.req;
  try {
    await drawgamesApiCaller.postPlayerObjectstore({
      data: {
        key,
        value,
        expires
      },
      req
    });
    logger.debug('Successfully posted to object store', {
      key,
      value,
      expires
    });
  } catch (error) {
    logger.error('Error posting to object store', error);
  }
};
const retrieveProlongData = async _ref3 => {
  var _productMapping$getPr, _cachedProlongData$ke2;
  let wagerId = _ref3.wagerId,
    productId = _ref3.productId,
    req = _ref3.req;
  const emptyResult = {
    filteredProlongData: null,
    key: null
  };
  const hasPlayerRole = isServer ? req === null || req === void 0 ? void 0 : req.userSession.hasRole(req.userSession.roles.PLAYER) : svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!hasPlayerRole) {
    logger.info('User is not logged in, cannot access prolong-storage');
    return emptyResult;
  }
  if (wagerId && !Number.isInteger(Number(wagerId))) {
    logger.error('wagerId must be a number', {
      wagerId
    });
    return emptyResult;
  }
  const keyId = ((_productMapping$getPr = productMapping.getProductName(productId)) === null || _productMapping$getPr === void 0 ? void 0 : _productMapping$getPr.toLowerCase()) || productId.toLowerCase();
  if (!keyMap[keyId]) {
    logger.error("".concat(keyId, " was not found in keyMap"));
    return emptyResult;
  }
  const key = keyMap[keyId];
  if ((_cachedProlongData$ke2 = cachedProlongData[key]) !== null && _cachedProlongData$ke2 !== void 0 && _cachedProlongData$ke2.data) {
    return {
      filteredProlongData: cachedProlongData[key].data,
      key
    };
  }
  if (inFlightProlongData[key]) {
    return inFlightProlongData[key];
  }
  const prolongDataPromise = (async _objectStoreData$resp => {
    const objectStoreData = await getObjectStoreData({
      key,
      req
    });
    if (!objectStoreData) {
      logger.error('Failed to retrieve object store data');
      return {
        filteredProlongData: {},
        key
      };
    }
    const items = isServer ? objectStoreData === null || objectStoreData === void 0 ? void 0 : objectStoreData.items : (_objectStoreData$resp = objectStoreData.response) === null || _objectStoreData$resp === void 0 ? void 0 : _objectStoreData$resp.items;
    let dataInObject = {};
    try {
      dataInObject = items !== null && items !== void 0 && items.length ? JSON.parse(items[0].value) : {};
    } catch (error) {
      logger.error('Failed to parse object store data', error);
      return {
        filteredProlongData: {},
        key
      };
    }
    const sevenDaysAgo = new Date(Date.now() - SEVEN_DAYS_IN_MS);
    const filteredProlongData = {};
    for (const _ref4 of Object.entries(dataInObject)) {
      var _ref5 = _slicedToArray(_ref4, 2);
      const wagerId = _ref5[0];
      const timestamp = _ref5[1];
      const wagerDate = new Date(timestamp);
      if (!isNaN(wagerDate.getTime()) && wagerDate >= sevenDaysAgo) {
        filteredProlongData[wagerId] = timestamp;
      }
    }
    setCachedData(key, filteredProlongData);
    logger.debug('Retrieved prolong data from object store', {
      key,
      filteredProlongData
    });
    return {
      filteredProlongData,
      key
    };
  })();
  inFlightProlongData[key] = prolongDataPromise;
  try {
    return await prolongDataPromise;
  } finally {
    delete inFlightProlongData[key];
  }
};
const set = async _ref6 => {
  var _productMapping$getPr2;
  let wagerId = _ref6.wagerId,
    productId = _ref6.productId,
    req = _ref6.req,
    _ref6$timestamp = _ref6.timestamp,
    timestamp = _ref6$timestamp === void 0 ? new Date().toISOString() : _ref6$timestamp;
  const keyId = ((_productMapping$getPr2 = productMapping.getProductName(productId)) === null || _productMapping$getPr2 === void 0 ? void 0 : _productMapping$getPr2.toLowerCase()) || productId.toLowerCase();
  const key = keyMap[keyId];
  if (!key) {
    logger.error("".concat(keyId, " was not found in keyMap"));
    return;
  }

  if (!inFlightSetOperations[key]) {
    inFlightSetOperations[key] = Promise.resolve();
  }
  const setPromise = (async () => {
    try {
      await inFlightSetOperations[key];
      const _await$retrieveProlon = await retrieveProlongData({
          wagerId,
          productId,
          req
        }),
        filteredProlongData = _await$retrieveProlon.filteredProlongData,
        retrievedKey = _await$retrieveProlon.key;
      if (!filteredProlongData || !retrievedKey) {
        logger.error('Could not set prolong data due to missing prolong data or key');
        return;
      }
      const newProlongData = _objectSpread(_objectSpread({}, filteredProlongData), {}, {
        [wagerId]: timestamp
      });
      let stringifyProlongData = JSON.stringify(newProlongData);

      while (stringifyProlongData.length > 1000) {
        const entries = Object.entries(newProlongData);
        const oldestEntry = entries.reduce((oldest, current) => new Date(current[1]) < new Date(oldest[1]) ? current : oldest);
        delete newProlongData[oldestEntry[0]];
        stringifyProlongData = JSON.stringify(newProlongData);
        logger.info('Removed oldest prolong entry to fit within size limit', {
          removedWagerId: oldestEntry[0],
          removedTimestamp: oldestEntry[1],
          newLength: stringifyProlongData.length
        });
      }
      setCachedData(key, newProlongData);
      await postToObjectStore({
        key,
        value: stringifyProlongData,
        expires: SEVEN_DAYS_IN_SECONDS,
        req
      });
    } catch (error) {
      logger.error('Error in set operation', error);
    }
  })();
  inFlightSetOperations[key] = setPromise;
  return setPromise;
};
const get = async _ref7 => {
  let wagerId = _ref7.wagerId,
    productId = _ref7.productId,
    req = _ref7.req;
  const _await$retrieveProlon2 = await retrieveProlongData({
      wagerId,
      productId,
      req
    }),
    filteredProlongData = _await$retrieveProlon2.filteredProlongData;
  if (filteredProlongData !== null && filteredProlongData !== void 0 && filteredProlongData[wagerId]) {
    return {
      timestamp: filteredProlongData[wagerId]
    };
  }
  return {
    timestamp: null
  };
};
if (isServer) {
  module.exports = {
    set,
    get
  };
} else {
  setGlobal('svs.tur.prolongStorage', {
    set,
    get
  });
}

 })(window);